// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rec-tbl-container {
  width: 100%;
}

.rec-tbl {
  width: 100%;
  border-collapse: collapse;

  table-layout: fixed;
}

.rec-tbl-hdr-row {
  height: 32px;
  border-bottom: 1px solid var(--border-line);
}

.rec-tbl-hdr-idx,
.rec-tbl-hdr-ctry,
.rec-tbl-hdr-ticker,
.rec-tbl-hdr-name,
.rec-tbl-hdr-price,
.rec-tbl-hdr-pct,
.rec-tbl-hdr-rec,
.rec-tbl-hdr-date {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-subheader);
  vertical-align: middle;
}

.rec-tbl-hdr-idx,
.rec-tbl-cell-idx {
  width: 26px;
  padding-left: 16px;
  text-align: left;
}

.rec-tbl-hdr-price,
.rec-tbl-hdr-pct,
.rec-tbl-hdr-date {
  text-align: right;
}

.rec-tbl-hdr-ctry,
.rec-tbl-cell-ctry {
  width: 48px;
  box-sizing: border-box;
  text-align: center;
  svg {
    width: 20px;
    height: 20px;
  }
}

.rec-tbl-hdr-ticker,
.rec-tbl-cell-ticker {
  width: 80px;
  text-align: left;
}

.rec-tbl-hdr-name,
.rec-tbl-cell-name {
  text-align: left;
}

@media (min-width: 768px) {
  .rec-tbl-hdr-name,
  .rec-tbl-cell-name {
    width: 25%;
  }
}

.rec-tbl-hdr-date,
.rec-tbl-cell-date {
  box-sizing: border-box;
  width: 104px;
  padding-right: 16px;
  text-align: right;
}

.rec-tbl-cell-row {
  height: 56px;
  box-sizing: border-box;

  &:first-child {
    padding-left: 4px;
  }

  &:nth-child(2n) {
    background-color: var(--row-dark);
  }
}

.rec-tbl-cell {
  box-sizing: border-box;
  vertical-align: middle;
}

.rec-tbl-cell-idx {
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: var(--text-subheader);
}

.rec-tbl tbody td {
  padding-top: 7px;
  padding-bottom: 7px;
}
.rec-tbl thead th:first-child {
  padding-left: 24px;
}
.rec-tbl tbody td:first-child {
  padding-left: 16px;
}

.rec-tbl-ticker-link {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  vertical-align: middle;
  text-underline-offset: 2px;
  cursor: pointer;
  color: var(--text-ticker);
}

.rec-tbl-name {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  vertical-align: middle;
  text-underline-offset: 1px;
  color: var(--text-instrument);
}

/* always underline ticker code, even when not a link */
.rec-tbl-cell-ticker span {
  font-size: 16px;
}

.rec-tbl-cell-name {
  font-weight: 400;
  font-size: 16px;
  /* company name smaller */
  line-height: 24px;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.rec-tbl-cell-price {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: right;
  color: var(--text-primary);
}

.rec-tbl-cell-pct {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: right;
  color: var(--text-unchg-color);
}

.rec-tbl-cell-pct.positive {
  color: var(--text-up-color);
}

.rec-tbl-cell-pct.negative {
  color: var(--text-down-color);
}

.rec-tbl-hdr-rec,
.rec-tbl-cell-rec {
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
  padding-right: 16px;
}

@media (min-width: 768px) {
  .rec-tbl-cell-row {
    height: 40px;
  }

  .rec-tbl-hdr-rec,
  .rec-tbl-cell-rec {
    padding-right: 0px;
    text-align: center;
  }

  .rec-tbl-hdr-ctry,
  .rec-tbl-cell-ctry {
    width: 68px;
    padding-right: 16px;
    text-align: left;
  }

  .rec-tbl-hdr-date,
  .rec-tbl-cell-date {
    padding-right: 32px;
  }

  .rec-tbl tbody td {
    padding: 7px 0;
  }

  .rec-tbl tbody td:first-child,
  .rec-tbl thead th:first-child {
    padding-left: 32px;
  }
}

.rec-tbl-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 1px;

  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
}

.rec-strong-buy {
  background-color: var(--heatmap-up-5);
  color: var(--text-invert);
}

.rec-buy {
  background-color: var(--heatmap-up-4);
  color: var(--text-invert);
}

.rec-hold {
  background-color: var(--surface-secondary);
  color: var(--text-primary);
}

.rec-reduce {
  background-color: var(--heatmap-donwn-4);
  color: var(--text-invert);
}

.rec-sell {
  background-color: var(--heatmap-down-6);
  color: var(--text-invert);
}

.rec-tbl-cell-date {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-primary);
}

/* Small screen merged Code / Company name column */
.rec-tbl-hdr-code-name {
  padding-left: 16px;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-subheader);
  text-align: left;
  white-space: nowrap;
}

.rec-tbl-cell-code-name {
  padding-right: 8px;
  vertical-align: middle;
}

.rec-tbl-code-name-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.rec-tbl-code-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ensure ticker underlined on small screen too */
.rec-tbl-code-row span {
  font-size: 16px;
}

.rec-tbl-company-name-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rec-tbl-flag-placeholder {
  width: 16px;
  /* flag width */
}

.rec-tbl-company-name {
  font-weight: 400;
  font-size: 14px;
  /* match new requirement */
  line-height: 16px;
  color: var(--text-subheader);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-left: 0px;
}

@media (min-width: 768px) {
  .rec-tbl-cell-name {
    text-underline-offset: 2px;
  }

  .rec-tbl-cell,
  .rec-tbl-cell-ctry {
    padding: 0px;
  }

  .rec-tbl tbody td:first-child {
    padding-left: 32px;
  }

  .rec-tbl tbody td:last-child {
    padding-right: 32px;
  }
  .rec-tbl thead th:last-child {
    padding-right: 20px;
  }
}

.rec-tbl-spacer {
  height: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/RecommendationTable/RecommendationTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;;EAEzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,sBAAsB;;EAEtB;IACE,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA,uDAAuD;AACvD;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;;EAEjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;;EAElB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,iDAAiD;AACjD;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;AACb","sourcesContent":[".rec-tbl-container {\n  width: 100%;\n}\n\n.rec-tbl {\n  width: 100%;\n  border-collapse: collapse;\n\n  table-layout: fixed;\n}\n\n.rec-tbl-hdr-row {\n  height: 32px;\n  border-bottom: 1px solid var(--border-line);\n}\n\n.rec-tbl-hdr-idx,\n.rec-tbl-hdr-ctry,\n.rec-tbl-hdr-ticker,\n.rec-tbl-hdr-name,\n.rec-tbl-hdr-price,\n.rec-tbl-hdr-pct,\n.rec-tbl-hdr-rec,\n.rec-tbl-hdr-date {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-subheader);\n  vertical-align: middle;\n}\n\n.rec-tbl-hdr-idx,\n.rec-tbl-cell-idx {\n  width: 26px;\n  padding-left: 16px;\n  text-align: left;\n}\n\n.rec-tbl-hdr-price,\n.rec-tbl-hdr-pct,\n.rec-tbl-hdr-date {\n  text-align: right;\n}\n\n.rec-tbl-hdr-ctry,\n.rec-tbl-cell-ctry {\n  width: 48px;\n  box-sizing: border-box;\n  text-align: center;\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n.rec-tbl-hdr-ticker,\n.rec-tbl-cell-ticker {\n  width: 80px;\n  text-align: left;\n}\n\n.rec-tbl-hdr-name,\n.rec-tbl-cell-name {\n  text-align: left;\n}\n\n@media (min-width: 768px) {\n  .rec-tbl-hdr-name,\n  .rec-tbl-cell-name {\n    width: 25%;\n  }\n}\n\n.rec-tbl-hdr-date,\n.rec-tbl-cell-date {\n  box-sizing: border-box;\n  width: 104px;\n  padding-right: 16px;\n  text-align: right;\n}\n\n.rec-tbl-cell-row {\n  height: 56px;\n  box-sizing: border-box;\n\n  &:first-child {\n    padding-left: 4px;\n  }\n\n  &:nth-child(2n) {\n    background-color: var(--row-dark);\n  }\n}\n\n.rec-tbl-cell {\n  box-sizing: border-box;\n  vertical-align: middle;\n}\n\n.rec-tbl-cell-idx {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: var(--text-subheader);\n}\n\n.rec-tbl tbody td {\n  padding-top: 7px;\n  padding-bottom: 7px;\n}\n.rec-tbl thead th:first-child {\n  padding-left: 24px;\n}\n.rec-tbl tbody td:first-child {\n  padding-left: 16px;\n}\n\n.rec-tbl-ticker-link {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  vertical-align: middle;\n  text-underline-offset: 2px;\n  cursor: pointer;\n  color: var(--text-ticker);\n}\n\n.rec-tbl-name {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  vertical-align: middle;\n  text-underline-offset: 1px;\n  color: var(--text-instrument);\n}\n\n/* always underline ticker code, even when not a link */\n.rec-tbl-cell-ticker span {\n  font-size: 16px;\n}\n\n.rec-tbl-cell-name {\n  font-weight: 400;\n  font-size: 16px;\n  /* company name smaller */\n  line-height: 24px;\n\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.rec-tbl-cell-price {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: right;\n  color: var(--text-primary);\n}\n\n.rec-tbl-cell-pct {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: right;\n  color: var(--text-unchg-color);\n}\n\n.rec-tbl-cell-pct.positive {\n  color: var(--text-up-color);\n}\n\n.rec-tbl-cell-pct.negative {\n  color: var(--text-down-color);\n}\n\n.rec-tbl-hdr-rec,\n.rec-tbl-cell-rec {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: right;\n  padding-right: 16px;\n}\n\n@media (min-width: 768px) {\n  .rec-tbl-cell-row {\n    height: 40px;\n  }\n\n  .rec-tbl-hdr-rec,\n  .rec-tbl-cell-rec {\n    padding-right: 0px;\n    text-align: center;\n  }\n\n  .rec-tbl-hdr-ctry,\n  .rec-tbl-cell-ctry {\n    width: 68px;\n    padding-right: 16px;\n    text-align: left;\n  }\n\n  .rec-tbl-hdr-date,\n  .rec-tbl-cell-date {\n    padding-right: 32px;\n  }\n\n  .rec-tbl tbody td {\n    padding: 7px 0;\n  }\n\n  .rec-tbl tbody td:first-child,\n  .rec-tbl thead th:first-child {\n    padding-left: 32px;\n  }\n}\n\n.rec-tbl-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 1px;\n\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0px;\n}\n\n.rec-strong-buy {\n  background-color: var(--heatmap-up-5);\n  color: var(--text-invert);\n}\n\n.rec-buy {\n  background-color: var(--heatmap-up-4);\n  color: var(--text-invert);\n}\n\n.rec-hold {\n  background-color: var(--surface-secondary);\n  color: var(--text-primary);\n}\n\n.rec-reduce {\n  background-color: var(--heatmap-donwn-4);\n  color: var(--text-invert);\n}\n\n.rec-sell {\n  background-color: var(--heatmap-down-6);\n  color: var(--text-invert);\n}\n\n.rec-tbl-cell-date {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-primary);\n}\n\n/* Small screen merged Code / Company name column */\n.rec-tbl-hdr-code-name {\n  padding-left: 16px;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-subheader);\n  text-align: left;\n  white-space: nowrap;\n}\n\n.rec-tbl-cell-code-name {\n  padding-right: 8px;\n  vertical-align: middle;\n}\n\n.rec-tbl-code-name-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.rec-tbl-code-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* ensure ticker underlined on small screen too */\n.rec-tbl-code-row span {\n  font-size: 16px;\n}\n\n.rec-tbl-company-name-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.rec-tbl-flag-placeholder {\n  width: 16px;\n  /* flag width */\n}\n\n.rec-tbl-company-name {\n  font-weight: 400;\n  font-size: 14px;\n  /* match new requirement */\n  line-height: 16px;\n  color: var(--text-subheader);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-left: 0px;\n}\n\n@media (min-width: 768px) {\n  .rec-tbl-cell-name {\n    text-underline-offset: 2px;\n  }\n\n  .rec-tbl-cell,\n  .rec-tbl-cell-ctry {\n    padding: 0px;\n  }\n\n  .rec-tbl tbody td:first-child {\n    padding-left: 32px;\n  }\n\n  .rec-tbl tbody td:last-child {\n    padding-right: 32px;\n  }\n  .rec-tbl thead th:last-child {\n    padding-right: 20px;\n  }\n}\n\n.rec-tbl-spacer {\n  height: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
